import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type DeleteProps = IconComponentBaseProps;

export const Delete = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: DeleteProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7352_3788"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7352_3788)">
        <path
          d="M7.30775 20.5C6.81058 20.5 6.385 20.323 6.031 19.969C5.677 19.615 5.5 19.1894 5.5 18.6922V5.99999H5.25C5.0375 5.99999 4.85942 5.92808 4.71575 5.78424C4.57192 5.64041 4.5 5.46224 4.5 5.24974C4.5 5.03708 4.57192 4.85899 4.71575 4.71549C4.85942 4.57183 5.0375 4.49999 5.25 4.49999H9C9 4.25516 9.08625 4.04649 9.25875 3.87399C9.43108 3.70166 9.63967 3.61549 9.8845 3.61549H14.1155C14.3603 3.61549 14.5689 3.70166 14.7413 3.87399C14.9138 4.04649 15 4.25516 15 4.49999H18.75C18.9625 4.49999 19.1406 4.57191 19.2843 4.71574C19.4281 4.85958 19.5 5.03774 19.5 5.25024C19.5 5.46291 19.4281 5.64099 19.2843 5.78449C19.1406 5.92816 18.9625 5.99999 18.75 5.99999H18.5V18.6922C18.5 19.1894 18.323 19.615 17.969 19.969C17.615 20.323 17.1894 20.5 16.6923 20.5H7.30775ZM17 5.99999H7V18.6922C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9712 7.21792 19 7.30775 19H16.6923C16.7821 19 16.8558 18.9712 16.9135 18.9135C16.9712 18.8558 17 18.7821 17 18.6922V5.99999ZM10.1543 17C10.3668 17 10.5448 16.9282 10.6885 16.7845C10.832 16.6407 10.9037 16.4625 10.9037 16.25V8.74999C10.9037 8.53749 10.8318 8.35933 10.688 8.21549C10.5443 8.07183 10.3662 7.99999 10.1535 7.99999C9.941 7.99999 9.76292 8.07183 9.61925 8.21549C9.47575 8.35933 9.404 8.53749 9.404 8.74999V16.25C9.404 16.4625 9.47583 16.6407 9.6195 16.7845C9.76333 16.9282 9.94158 17 10.1543 17ZM13.8465 17C14.059 17 14.2371 16.9282 14.3807 16.7845C14.5243 16.6407 14.596 16.4625 14.596 16.25V8.74999C14.596 8.53749 14.5242 8.35933 14.3805 8.21549C14.2367 8.07183 14.0584 7.99999 13.8458 7.99999C13.6333 7.99999 13.4552 8.07183 13.3115 8.21549C13.168 8.35933 13.0962 8.53749 13.0962 8.74999V16.25C13.0962 16.4625 13.1682 16.6407 13.312 16.7845C13.4557 16.9282 13.6338 17 13.8465 17Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
